export function getLocationHostDomain(): string {
	const regExpExecArray = (/\w+\.\w+$/u).exec(location.host);

	return regExpExecArray
		? regExpExecArray[0] // hostdomain
		: 'localhost';
}
